<template>
  <div id="content" class="startup_page">
    <ConfirmModal :dialogVisible='showConfirmDialog' @close="closeConfirmDialog()" @confirmed="confirmRemove($event)" message="Remove your list ?" ></ConfirmModal>

    <!-- <div class="" >
      <div class="all_candidates_download_zone ">
        <div class="col-12r">
          <div>
            <span class="title" @click='toggle = !toggle'>Import your candidates
              <img :src="require('@/assets/triangle.svg')" class="triangle" :class='(toggle == true) ? "open" : "not-open"' alt="">
            </span>

          </div>
          <div class="row" v-if="toggle == true" >
           <div class="col-12 col-lg-6 mt20">
               <span class="pool_subtitle ">Step 1</span><br/>
             <a href="/doc/example_import.xlsx" target="_blank" download>Download and complete our template file in Excel format</a><br/>
                  <a href="/doc/example_import.csv" target="_blank" download>Download and complete our template file in CSV format</a>

           </div>
            <div class="col-12 col-lg-6 mt20">
             <span class="pool_subtitle ">Step 2</span>
             <LongListUploader :dialogVisible='dialogFullSetFile' @close="dialogFullSetFile=false" @fileUploaded="setLongList()"  :search_field="this.$route.params.search_field"></LongListUploader>
           </div>
         </div>

       </div>
     </div>
   </div> -->

      <div class="content_div stats">
        <h1 class="customH2">Pools for {{searchfield.name}}</h1>
        <div class="loaderInnopearl " v-if="loading">
          <div class="loaderInnopearlInner">
            <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
            <span>Loading in progress</span>
          </div>

        </div>
        <div class="row" v-if="filterPoolList.length > 0 || my_assessment_pool.length > 0">
          <div class="col-12 col-md-6 col-xl-4 candidate" v-if="my_assessment_pool.length > 0  && !onlyLongList">
            <div class="candidate_card"   >
              <div class="candidate_card_head">
                <span class="name">{{$t("Selected for assessment")}}</span>

              </div>
              <div class="candidate_info_content">
                <StartupInfoLine name="Candidates" :value=" (my_assessment_pool.length > 1) ? my_assessment_pool.length+' candidates' : my_assessment_pool.length+' candidate'"  />

              </div>
              <div class="footer">
                <router-link class="detail" :to="'/manage_assessments?project='+project"  >
                Details
                </router-link>
              </div>
            </div>

          </div>
          <div class="col-12 col-md-6 col-xl-4 candidate" v-for="(pool, c) in filterPoolList" :key="c">
            <div class="candidate_card"  :class="[ pool.isLongList ? 'isAssess' : 'notAssess']" >
              <div :class="[ pool.byInnopearl ? 'candidate_card_head innopearl' : 'candidate_card_head']">
                <span class="name" v-if="pool.isLongList">Long list</span>
                <span class="name" v-else>
                  <span v-if="pool.name">{{pool.name}}</span>
                  <span v-else>Pool without name</span>
                </span>
              </div>
              <div class="candidate_info_content">
                <StartupInfoLine v-if="pool.candidates" name="Candidates" :value=" (pool.candidates.length > 1) ? pool.candidates.length+' candidates' : pool.candidates.length+' candidate'"  />
                <StartupInfoLine v-if="pool.createdAt" name="Created" :value="pool.createdAt" :isDate='true'/>

              </div>
              <div class="footer">
                <button type="button" v-if="pool.isLongList != true" class="removeBtn" name="button" @click="displayConfirmDialog(pool._id.$oid)">Remove</button>
                <router-link class="detail" :to="'/new_startup_with_filters/'+$route.params.search_field+'/'+$route.params.pid+'/'+pool._id.$oid"  >
                Details
                </router-link>
              </div>
            </div>

          </div>
        </div>
        <div class="row" v-else>
          <div class="alert alert-warning text-center" v-if="!loading">
             You don't have any pools yet
          </div>
        </div>

        <div class="row center mt50 pad-50">
          <div class="col-12">
            <button v-if="canGoBack" class="prev_step_btn" @click="gobackrouter()">
              <img :src="require('@/assets/prev.svg')" alt="">
              GO BACK
            </button>
          </div>

        </div>
      </div>
  </div>
</template>
<script>
import api from '../tools/api';
// import router from '@/router'
import StartupInfoLine from '@/components/InfoStartupLine.vue'
 import { toast } from 'vue-sonner'
   // import LongListUploader from '@/components/LongListUploader.vue'
   import ConfirmModal from '@/components/modals/ConfirmModal.vue';
export default {
  components: {
    StartupInfoLine,
    // LongListUploader,
    ConfirmModal
  },
  name: 'List_My_Filter',
  data() {
    return {
      pageInfo: {
        mainTitle : "Partners’ qualifications:",
        subTitle : "Evaluate and prioritize the best options ",
      },
      project : null,
      my_assessment_pool: [],
      toggle: false,
      loading:false,
      hideLongList: true,
      onlyLongList:false,
      dialogFullSetFile: false,
      showConfirmDialog: false,
      my_pools: [],
      filterPoolList: [],
      searchfield: {candidatesPools: []}
    }
  },
  methods:{
    closeConfirmDialog(){
      this.showConfirmDialog = false;
      this.poolAskedForRemove = null;
    },
    displayConfirmDialog(poolid){
      this.showConfirmDialog = true;
      this.poolAskedForRemove = poolid;
    },
    confirmRemove(){
      this.showConfirmDialog = false;
      this.removePool(this.poolAskedForRemove);
      this.poolAskedForRemove = null;
    },
    removePool(poolid){

        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/removePool",
            {
              pool : poolid,
              search_field : this.$route.params.search_field
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( (r) => {
            toast.success("List successfully removed");
            console.log(r);
            api.get(process.env.VUE_APP_API_URL+"/restrict/my_pools/"+this.$route.params.search_field).then( (r) => {
              console.log("FILTERS");
              console.log(r.data);
              this.my_pools = r.data.pools;
              this.searchfield = r.data;
              if(this.hideLongList){
                console.log("HDIEQSFQF qsfodpqisf pqsofiqpsfdip ");
                this.filterPoolList = this.searchfield.candidatesPools.filter(obj => obj.isLongList !== true);
              }
              else if(this.onlyLongList){
                this.filterPoolList = this.searchfield.candidatesPools.filter(obj => obj.isLongList == true);

              }
              else{
                console.log("toia");
                this.filterPoolList = this.searchfield.candidatesPools;
              }
            }).catch( (e) => {
              console.log(e);
               toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
          }).catch( () => {
              toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });

    },
    gobackrouter : function(){
      this.$router.go(-1);
    },
    setLongList(){

      this.dialogFullSetFile = false;
      api.get(process.env.VUE_APP_API_URL+"/restrict/my_pools/"+this.$route.params.search_field).then( (r) => {
        console.log("FILTERS");
        console.log(r.data);
        this.my_pools = r.data.pools;

        this.searchfield = r.data;
        this.searchfield.candidatesPools = this.searchfield.candidatesPools.reverse();

        if(this.hideLongList){
          console.log("HDIEQSFQF qsfodpqisf pqsofiqpsfdip ");
          this.filterPoolList = this.searchfield.candidatesPools.filter(obj => obj.isLongList !== true);
        }
        else if(this.onlyLongList){
          this.filterPoolList = this.searchfield.candidatesPools.filter(obj => obj.isLongList == true);

        }
        else{
          console.log("toia");
          this.filterPoolList = this.searchfield.candidatesPools;
        }
      }).catch( (e) => {
        console.log(e);
         toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });
    },
  },
  computed: {
    canGoBack() {
      // console.log("router");
      // console.log(this.$router.currentRoute.matched);
      // console.log(window.history);
      //return this.$router.history.length > 1;
      if(window.history)
        if(window.history.length > 1)return true;
      return false;

    },

  },
  mounted(){
    this.project = this.$route.params.pid;
    this.loading = true;
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
     console.log("fqsdfqffsdf",this.$route.query.noLongList);
     if(this.$route.query.noLongList){
       if(Boolean(this.$route.query.noLongList) == true){
         this.hideLongList =true;
       }
       else{
            this.hideLongList =false;
       }
     }
     else{
       this.hideLongList =false;
     }

     if(this.$route.query.onlyLongList){
       if(Boolean(this.$route.query.onlyLongList) == true){
         this.onlyLongList =true;
       }
       else{
            this.onlyLongList =false;
       }
     }
     else{
       this.onlyLongList =false;
     }
     api.get(process.env.VUE_APP_API_URL+"/restrict/my_assessment_pool/"+this.$route.params.pid).then( (r) => {
       console.log("my_assessment_pool");
       console.log(r.data);
       this.my_assessment_pool = r.data;

     }).catch( (e) => {
       console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
   });
     api.get(process.env.VUE_APP_API_URL+"/restrict/my_pools/"+this.$route.params.search_field).then( (r) => {
       // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
       // console.log();
       // var temp = _.merge(this.candidatespool, r.data)
       console.log("FILTERS");
       console.log(r.data);
       this.my_pools = r.data.pools;
       this.searchfield = r.data;
       if(this.searchfield.candidatesPools)this.searchfield.candidatesPools = this.searchfield.candidatesPools.reverse();
       if(this.hideLongList){
         console.log("HDIEQSFQF qsfodpqisf pqsofiqpsfdip ");
         this.filterPoolList = this.searchfield.candidatesPools.filter(obj => obj.isLongList !== true);
       }
       else if(this.onlyLongList){
         this.filterPoolList = this.searchfield.candidatesPools.filter(obj => obj.isLongList == true);

       }
       else{
         console.log("toia");
         this.filterPoolList = this.searchfield.candidatesPools;
       }
       this.loading = false;
     }).catch( (e) => {
       console.log(e);
       this.loading = false;
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
   });
  },


}
</script>
<style scoped>

.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.chart-container {
  position: relative;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
  display:inline-block;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.canvasjs-chart-credit{
  display:none;
}

.chartDiv{
  margin:auto;
}
.col-center{
  text-align: center;
}
.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: #3783C5;
}
.zone_input_header{
  display:flex;
  align-items: center;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
box-sizing: border-box;
margin-top:10px;
margin-bottom: 20px;
height: 40px;
padding: 5px;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}


.customH2{
    color: #3783C5;
    font-size:21px;
    text-transform:uppercase;
    margin-bottom:20px;
}
.v-field--variant-filled .v-field__overlay{
  background:#FFF !important;
}

.dateSelectors{
  display:flex;
  flex-direction:row;
  gap:20px;
}
.dateSelectors label{
  flex:1;
}
.next_step_btn svg{
  margin-right:15px;
}
.filterBtnDiv{
  margin-top:20px;
}
@media screen and (max-width:800px){
  .dateSelectors{
    display:flex;
    flex-direction:column;
    gap:20px;
  }
  .dateSelectors label{
    width:100%;
  }
}


.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}


.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;

}
.candidate_card .candidate_info_content{
  padding:20px;
  flex-grow: 1;
}
.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}

.candidate_card_head{
  background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;

  padding: 10px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px;
  display:flex;
  align-content: center;
    align-items: center;
gap:10px;
min-height: 60px;
}

.candidate_card_head .name{
  flex:1;
}
.footer{
padding-left: 20px;
  padding-right: 20px;
    padding-bottom: 10px;
  font-weight:bold;
  text-transform: uppercase;
  color:#B38D2F !important;
  font-size:14px;
  display:flex;
  flex-wrap:wrap;
  gap:10px;
}
.removeBtn{
  color: #dd6a6a !important;
  border: 1px solid #dd6a6a;
  padding: 5px 10px;
  border-radius: 20px;
}
.footer a{
  margin-left: auto;  color:#4c81c0 !important;
}
.footer *{

  font-size:14px;
}

.candidate_card.isAssess{
  border-color:#ad8e41;
}
.candidate_card.isAssess .candidate_card_head{
  background:#ad8e41;
}
.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
margin-bottom:50px;
}
.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
}
.all_candidates_download_zone .description{
  display:block;
  margin-top:10px;
  margin-bottom: 20px;
  width:100%;
}

.all_candidates_download_zone .title{
  font-size: 20px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
font-weight:500;
cursor:pointer;
}
.all_candidates_download_zone a{
  color:#B38D2F !important;
}
</style>
<style>
.dp__pointer{
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.dp__input_icon {
  cursor: pointer;
  position: absolute;
  top: 50%;

  left: 10px !important;
}
.input-slot-image{
  width:100% !important;
  height:100% !important;
  object-fit: contain;
  object-position: center;
  display: block;
}



.filter{
  padding-top:25px;
  padding-bottom:25px;
  border-bottom:1px dashed #000;
  display:flex;
}
.filter_info{
  flex:1;
}
.details{
  font-size:12px;
  line-height: 15px;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
}

.actions{
  margin-top:20px;
}
.remove{
  border:1px solid #C63221;
  color:#C63221;
  background:#FFF;
  padding:5px;
  font-size:12px;
  line-height: 15px;
  margin-left:10px;
}

.triangle{
  width:15px;
}

.triangle.open{
  transform:rotate(180deg);
}

.mt50{
  margin-top:50px;
}
@media screen and (min-width:1000px) and (max-width:1650px){
  .candidate {
    flex: 0 0 auto;
    width: 50%;
  }

}

.candidate_card_head.innopearl{
  background:  linear-gradient(105deg, #1D2091 0%, #3783C5 100%) !important;
}
.detail{
  background: #F1F6FB;
padding: 10px 20px;
border-radius: 50px;
text-align: center;
}
</style>
